var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M64 18.66a2.2 2.2 0 0 1-.64 1.474L33.474 50.019a2.016 2.016 0 0 1-2.947 0L.64 20.133a2.016 2.016 0 0 1 0-2.947l3.206-3.206a2.1 2.1 0 0 1 1.474-.64 2.2 2.2 0 0 1 1.474.64L32 39.187l25.207-25.206a2.016 2.016 0 0 1 2.947 0l3.206 3.206A2.2 2.2 0 0 1 64 18.66"
})));
export { SvgChevronDown as ReactComponent };